import { motion } from 'motion/react';
import type { WorkOption } from '../types';

interface OthersShapesProps {
  step?: 1 | 2 | 3;
  selectedWorkOption: WorkOption | null;
}

export function OthersShapes({ step = 1, selectedWorkOption }: OthersShapesProps): JSX.Element {
  const getContainerStyle = () => {
    if (step === 3) {
      return { transform: 'translate(-160px, 160px) scale(1)', opacity: 1 };
    }
    if (step === 2 && selectedWorkOption !== null) {
      return { transform: 'translate(-200px, -200px) scale(0.9)', opacity: 0.4 };
    }
    return undefined;
  };

  return (
    <div
      className="absolute left-[500px] top-[380px] transition-all duration-1000"
      style={getContainerStyle()}
    >
      <motion.div
        initial={{ opacity: 0, rotate: 90, scale: 0.7 }}
        animate={{ opacity: 1, rotate: 0, scale: 1 }}
        exit={{ opacity: 0, rotate: -90, scale: 0.7 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <svg
          width="270"
          height="270"
          viewBox="0 0 270 270"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_9861_2419)">
            <mask
              id="mask0_9861_2419"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="270"
              height="270"
            >
              <path d="M269.488 0H0V269.488H269.488V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_9861_2419)">
              <path
                d="M134.744 234.102C32.8296 319.268 -49.7796 236.659 35.3866 134.744C-49.7796 32.8296 32.8296 -49.7796 134.744 35.3866C236.639 -49.7796 319.268 32.8296 234.102 134.744C319.268 236.581 236.639 319.268 134.744 234.102Z"
                fill="#FFB8B8"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_9861_2419">
              <rect width="269.488" height="269.488" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </motion.div>
      <motion.div
        className="absolute -left-[200px] -top-[80px]"
        initial={{ opacity: 0, scale: 0.4 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.4 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
      >
        <svg
          width="271"
          height="271"
          viewBox="0 0 271 271"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_9861_2396)">
            <mask
              id="mask0_9861_2396"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="271"
              height="271"
            >
              <path d="M270.151 0H0V270.151H270.151V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_9861_2396)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M67.5378 135.076C104.838 135.076 135.076 104.838 135.076 67.5378C135.076 104.838 165.314 135.076 202.614 135.076C165.314 135.076 135.076 165.314 135.076 202.614C135.076 165.314 104.838 135.076 67.5378 135.076ZM67.5378 135.076C30.2378 135.076 0 165.314 0 202.614C0 239.913 30.2378 270.151 67.5378 270.151C104.838 270.151 135.076 239.913 135.076 202.614C135.076 239.913 165.314 270.151 202.614 270.151C239.913 270.151 270.151 239.913 270.151 202.614C270.151 165.314 239.913 135.076 202.614 135.076C239.913 135.076 270.151 104.838 270.151 67.5378C270.151 30.2378 239.913 0 202.614 0C165.314 0 135.076 30.2378 135.076 67.5378C135.076 30.2378 104.838 0 67.5378 0C30.2378 0 0 30.2378 0 67.5378C0 104.838 30.2378 135.076 67.5378 135.076Z"
                fill="#3898FF"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_9861_2396">
              <rect width="270.151" height="270.151" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </motion.div>
    </div>
  );
}
